import statuses from '@/helpers/statuses'
import { ALL_MEMBERS_ID } from '@/helpers/constants'

const initialState = () => ({
  teams: {},
  list: [],
  meta: {
    loading: statuses.IDLE
  }
})

export default api => ({
  state: initialState,

  getters: {
    teamsLoading: state => state.meta.loading,
    team: state => id => state.teams[id],
    teams: state => state.list.map(id => state.teams[id]),
    teamsWithAll: state => {
      const list = state.teams[ALL_MEMBERS_ID] ? [...state.list, ALL_MEMBERS_ID] : state.list
      return list.map(id => state.teams[id])
    },

    profileTeams: (state, getters) => profileId =>
      getters.teams.filter(team =>
        team.members.findIndex(member => member.profile === profileId) !== -1)
  },

  mutations: {
    fetchTeams: state => {
      state.meta.loading = statuses.LOADING
    },

    fetchTeamsSuccess: (state, { teams, list }) => {
      state.meta.loading = statuses.LOADED
      state.teams = teams
      state.list = list
    },

    fetchTeamsFailure: (state, error) => {
      state.meta.loading = statuses.FAILED
    },

    fetchTeam: (state, teams) => {
      state.teams = { ...state.teams, ...teams }
    },

    updateTeam: (state, team) => {
      state.teams = { ...state.teams, [team.id]: team }
    },

    createTeam: (state, { teams, id }) => {
      state.teams = { ...state.teams, ...teams }
      state.list = [...state.list, id]
    },

    resetTeams: state => {
      const payload = initialState()
      Object.keys(payload).forEach(key => {
        state[key] = payload[key]
      })
    }
  },

  actions: {
    fetchTeams: async ({ commit }) => {
      const slug = api.getWorkspaceSlug()
      commit('fetchTeams')
      try {
        const { entities: { teams, profiles }, result } = await api.fetchTeams(slug)
        commit('fetchTeamsSuccess', { teams, list: result })
        commit('updateProfiles', profiles)
      } catch (error) {
        commit('fetchTeamsFailure', error)
      }
    },

    fetchTeam: async ({ commit }, id) => {
      const slug = api.getWorkspaceSlug()
      const { entities: { teams, profiles } } = await api.fetchTeam(slug, id)
      commit('fetchTeam', teams)
      commit('updateProfiles', profiles)
    },

    createTeam: async ({ commit }, data) => {
      const slug = api.getWorkspaceSlug()
      const { entities: { teams, profiles }, result } = await api.createTeam(slug, data)
      commit('createTeam', { teams, id: result })
      commit('updateProfiles', profiles)
      return result
    },

    updateTeam: async ({ commit }, { id, data }) => {
      const slug = api.getWorkspaceSlug()
      const { entities: { teams, profiles } } = await api.updateTeam(slug, id, data)
      commit('fetchTeam', teams)
      commit('updateProfiles', profiles)
    },

    addTeamMember: async ({ commit }, { teamId, memberId }) => {
      const slug = api.getWorkspaceSlug()
      await api.addTeamMember(slug, teamId, memberId)
    },

    deleteTeamMember: async ({ commit }, { teamId, memberId }) => {
      const slug = api.getWorkspaceSlug()
      await api.deleteTeamMember(slug, teamId, memberId)
    },

    clear: ({ commit }) => {
      commit('resetTeams')
    }
  }
})
